export const ISA_AVATAR_PATHS = [
  '/isa/isa.png',
  '/isa/isa-2.png',
  '/isa/isa-3.png',
  '/isa/isa-4.png',
] as const

export const DEFAULT_ISA_AVATAR = ISA_AVATAR_PATHS[0]

/** Escolhe uma foto da Isa ao carregar o app (sem rotação periódica). */
export function pickRandomIsaAvatar(): string {
  const index = Math.floor(Math.random() * ISA_AVATAR_PATHS.length)
  return ISA_AVATAR_PATHS[index]
}
